import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'api';

export const PUBLIC_API_REDUCER_KEY = 'publicApi';

export const publicApi = createApi({
  reducerPath: PUBLIC_API_REDUCER_KEY,
  baseQuery: axiosBaseQuery(),
  tagTypes: [
    'ScreenConfigs',
    'Categories',
    'B2BStores',
    'B2BItems',
    'PromoCodes',
    'Tags',
    'B2BNearByStores',
  ],
  endpoints: () => ({}),
});
